import { join, split } from 'lodash'
import { IFormPregunta, IModelPregunta, IModelPreguntaForm } from '../../model/candidato-api'

export class PreguntaForm implements IFormPregunta {
  data: IModelPreguntaForm
  q: IModelPregunta
  eliminar: boolean

  title: string
  tipoq: string

  options: string[] = []

  constructor(data: IModelPreguntaForm) {
    this.data = data
    this.eliminar = false
  }

  get permiteEditar() {
    return this.q && this.q.tipoq === 'MULTIPLE'
  }

  get pregEnlazada() {
    return !!this.q
  }

  update(response: IFormPregunta) {
    if (response.q) {
      this.q = response.q

      this.title = response.q && response.q.texto_en
      this.tipoq = response.q && response.q.tipoq

      // generar las opciones del select, están en la pregunta del bloque
      if (response.q.tipoq == 'MULTIPLE') {
        this.options = split(this.data.options, '|')
      }
    }

    this.eliminar = false

    return this
  }

  toggleVisible() {
    this.data.visibleEnForm = !this.data.visibleEnForm
  }

  toggleEliminar() {
    this.eliminar = !this.eliminar
  }

  desdePregunta(p: IModelPregunta) {
    this.q = p
    this.data.quest_id = p.idquest
    this.title = p.texto_en
    this.tipoq = p.tipoq
  }

  beforeSave() {
    // generar las opciones del select
    if (this.q && this.q.tipoq == 'MULTIPLE') {
      this.data.options = join(this.options, '|')
    }
  }
}
